/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import Polyglot from 'node-polyglot';

const locale = 'en';
const phrases = {};
const onMissingKey = key => {
  console.warn(`Missing translation for key: "${key}"`);

  return key;
};

const p = new Polyglot({ locale, phrases, onMissingKey });

export default p;
